export function getW3mThemeVariables(themeVariables, themeType) {
    if (themeType === 'light') {
        return {
            '--w3m-accent': themeVariables?.['--w3m-accent'] || '#5773ff',
            '--w3m-background': '#fff'
        };
    }
    return {
        '--w3m-accent': themeVariables?.['--w3m-accent'] || '#667dff',
        '--w3m-background': '#121313'
    };
}
//# sourceMappingURL=ThemeUtil.js.map